export const containerStyle = {
  marginTop: 40,
};

export const titleContainerStyle = {
  marginBottom: 16,
};

export const titleStyle = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 4,
};

export const tableStyles = `
  .row-avaliando {
    background-color: #e6f7ff !important;
  }
  .row-avaliando:hover {
    background-color: #bae7ff !important;
  }
  .row-com-problema {
    background-color: #fff1f0 !important;
    border-left: 3px solid #ff4d4f !important;
  }
  .row-com-problema:hover {
    background-color: #ffccc7 !important;
  }
`;

export const cellCenterStyle = {
  textAlign: 'center' as const,
  fontWeight: 500,
  color: '#666',
};

export const cellReadonlyStyle = {
  textAlign: 'center' as const,
  fontWeight: 500,
  color: '#8c8c8c',
  backgroundColor: '#f5f5f5',
  padding: '4px 11px',
  borderRadius: '2px',
};

export const cellHighlightBlueStyle = {
  textAlign: 'right' as const,
  fontWeight: 500,
  color: '#1890ff',
};

export const cellHighlightGreenStyle = {
  textAlign: 'right' as const,
  fontWeight: 600,
  color: '#52c41a',
  fontSize: 14,
};
